module.exports = __webpack_public_path__ + "static/media/favicon.1dc8a738.ico";